import { EMAIL_VALIDATION_PATTERN, STRING_VALIDATION_PATTERN } from './constants/constants';
import { UserTypes } from './enums';
import { FieldConfig, Option, RegistrationType, User } from './types/types';
import { IconType } from './ui';

export const fakeUser = {
  name: 'Richard',
  surname: 'Hendricks',
  role: 'Owner',
  img: '',
};

export const supportedUILanguages: Option[] = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
];

export const fakeUsers: User[] = [
  {
    id: '1',
    name: 'Mathias',
    surname: 'Nielsen',
    role: UserTypes.OWNER,
  },
  {
    id: '2',
    name: 'Deepak',
    surname: 'Tharuk',
    email: 'email',
    role: UserTypes.MANAGER,
  },
  {
    id: '3',
    name: 'Laura',
    surname: 'Crone',
    role: UserTypes.ASSISTANT_MANAGER,
  },
];

export const inputFields: FieldConfig[] = [
  {
    name: 'firstName',
    labelKey: 'name',
    placeholderKey: 'placeholders.name',
    type: 'text',
    validationRules: {
      required: 'required.name',
      pattern: {
        value: STRING_VALIDATION_PATTERN,
        message: 'errors.name',
      },
    },
  },
  {
    name: 'lastName',
    labelKey: 'surname',
    placeholderKey: 'placeholders.surname',
    type: 'text',
    validationRules: {
      required: 'required.surname',
      pattern: {
        value: STRING_VALIDATION_PATTERN,
        message: 'errors.surname',
      },
    },
  },
  {
    name: 'email',
    labelKey: 'email',
    placeholderKey: 'placeholders.email',
    type: 'email',
    validationRules: {
      required: 'required.email',
      pattern: {
        value: EMAIL_VALIDATION_PATTERN,
        message: 'errors.email',
      },
    },
  },
  {
    name: 'phone',
    labelKey: 'phone',
    placeholderKey: 'placeholders.phone',
    type: 'text',
    validationRules: {},
  },
  {
    name: 'role',
    labelKey: 'role',
    placeholderKey: 'placeholders.role',
    type: 'select',
    options: [],
    validationRules: {
      required: 'required.role',
    },
  },
];

export const getEmployeeFormFields = ({ rolesOptions }: { rolesOptions: any[] }): FieldConfig[] => [
  {
    name: 'firstName',
    labelKey: 'name',
    placeholderKey: 'placeholders.name',
    type: 'text',
    validationRules: {
      required: 'required.name',
      pattern: {
        value: STRING_VALIDATION_PATTERN,
        message: 'errors.name',
      },
    },
  },
  {
    name: 'lastName',
    labelKey: 'surname',
    placeholderKey: 'placeholders.surname',
    type: 'text',
    validationRules: {
      required: 'required.surname',
      pattern: {
        value: STRING_VALIDATION_PATTERN,
        message: 'errors.surname',
      },
    },
  },
  {
    name: 'phone',
    labelKey: 'phone',
    placeholderKey: 'placeholders.phone',
    type: 'text',
    validationRules: {
      required: 'required.phone',
    },
  },
  {
    name: 'role',
    labelKey: 'role',
    placeholderKey: 'placeholders.role',
    type: 'select',
    options: rolesOptions,
    validationRules: {
      required: 'required.role',
    },
  },
  {
    name: 'pincode',
    labelKey: 'pincode',
    placeholderKey: 'placeholders.pincode',
    type: 'text',
    validationRules: {
      required: 'required.pincode',
      pattern: {
        value: /^\d{4}$/,
        message: 'errors.pincode',
      },
    },
  },
];

export const buildLinks = [
  {
    type: 'Build',
    hasDropdown: false,
    href: '/builder/build',
    text: 'builds',
  },
  {
    type: 'Blocks',
    text: 'global_blocks',
    hasDropdown: false,
    href: '/builder/global-blocks',
  },
  {
    type: 'Media',
    text: 'media',
    hasDropdown: false,
    href: '/builder/media',
  },
  // { type: 'AppStore', text: 'app_store', hasDropdown: true }
];

export const businesses: RegistrationType[] = [
  {
    label: 'General retail',
    value: 'general_retail',
    icon: IconType.Tshirt,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Quick Service',
    value: 'quick_service',
    icon: IconType.Basket,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Restaurant',
    value: 'restaurant',
    icon: IconType.Pizza,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Service',
    value: 'service',
    icon: IconType.Heart,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Reseller / Developer',
    value: 'reseller',
    icon: IconType.Developer,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Other',
    value: 'other',
    icon: IconType.Coin,
    width: '100%',
    height: '100%',
  },
];
export const firstPageData = [
  {
    label: 'For own use',
    value: 'owner',
    icon: IconType.Tshirt,
    width: '100%',
    height: '100%',
  },
  {
    label: 'Agency/ Reseller',
    value: 'agency',
    icon: IconType.Pizza,
    width: '100%',
    height: '100%',
  },
];

export const revenues = [
  {
    label: '0-100k',
    value: '0-100k',
  },
  {
    label: '100k-500k',
    value: '100k-500k',
  },
  {
    label: '500k-1m',
    value: '500k-1m',
  },
  {
    label: '1m-5m',
    value: '1m-5m',
  },
  {
    label: '5m-10m',
    value: '5m-10m',
  },
  {
    label: '10m+',
    value: '10m+',
  },
];
